export default __webpack_public_path__ + "static/media/face_analysis_image.bd72bafa.jpg";